import React from "react";
import { Typography, Box } from "@mui/material";
import cupImage from "../../../iamges/cup.png";
import android from "../../../iamges/android-download.png";
import ios from "../../../iamges/ios-download.png";
import "./RentingSection.scss";

const RentingSection = () => {
  const list = [
    { text: "Step-by-step notice procedures for every Canadian province" },
    { text: "Smart recommendations for missed rent actions" },
    { text: "Stay legally compliant with province-specific rules" },
    { text: "Get timely rent reminders" },
    { text: "Maintain rental dues with flexibility" },
  ];
  return (
    <div className='RentingSection'>
      <Box className='section-flex'>
        <div className='renting-left-side'>
          <Typography className='rental-app-badge'>RENTAL APP</Typography>
        </div>
      </Box>
      <Box className='section-flex'>
        <div className='renting-left-side'>
          <h2 className='rental-section-title'>Renting was never easy</h2>

          <p className='rental-section-desc' id='download'>
            Many landlords struggle with rent tracking, tenant follow-ups, and
            uncertainty around legal actions.
          </p>

          <p className='rental-section-desc'>
            HomeOwner Rental simplifies everything with automated tools, a smart
            tenant management system Canada, and legal-ready workflows — making
            it one of the most practical rental property tools for landlords in
            Canada.
          </p>

          <div className='pricing-clarity-wrapper'>
            <p className='pricing-clarity-line'>
              Rental tools are a one-time $20 unlock, no subscription. Optional
              tax reports are $2.99 per property, per year. Moving tools are
              free.
            </p>
          </div>
        </div>

        <div className='renting-right-side'>
          {list.map((item, index) => {
            return (
              <div
                className='white-box'
                key={`item-${item.text}`}
                style={{ height: "auto" }}>
                <img src={cupImage} alt='trophy cup' />
                <Typography>{item.text}</Typography>
              </div>
            );
          })}
        </div>
      </Box>

      <div className='app-download-wrapper'>
        <h4 className='app-download-text'>Download the app now!</h4>
        <div className='app-download-image-wrapper'>
          <a href='https://play.google.com/store/apps/details?id=com.arptix.homeowner'>
            <img src={android} alt='android' />
          </a>
          <a href='https://apps.apple.com/ca/app/homeowner/id6448795356'>
            <img src={ios} alt='ios' />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RentingSection;
